<template>
	<component :is="productComponent" :category="selectedCategory" />
</template>
<script>
import { mapGetters } from 'vuex'
// import ComboPackage from '@/views/ComboPackage'
// import Sandwiches from '@/views/Sandwiches'
// import Lunchboxes from '@/views/Lunchboxes'
// import Drinks from '@/views/Drinks'
// import Cookies from '@/views/Cookies'
import ProductIndex from '../../components/product/Index'

export default {
  name: 'ProductList',
  data () {
    return {
      productComponent: null
    }
  },
  components: {
    ProductIndex
  },
  created () {
    this.productComponent = ProductIndex
  },
  computed: {
    ...mapGetters('category', ['categoryList']),
    selectedCategory () {
      if (this.categoryList === null || this.categoryList.length < 1) {
        this.$store.dispatch('category/getCategory')
          .then((catlist) => {
            const tmpCategory = catlist.filter(a => a.UrlAliase === this.$route.path)
            if (tmpCategory !== null && tmpCategory.length > 0) {
              return tmpCategory[0]
            }
            return null
          })
      } else {
        const tmpCategory = this.categoryList.filter(a => a.UrlAliase === this.$route.path)
        if (tmpCategory !== null && tmpCategory.length > 0) {
          return tmpCategory[0]
        }
        return null
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/product/ProductList.vue